import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Container } from '@material-ui/core';
import Drawer from './Drawer';
import PlanForm from './PlanForm';
import SelectPlan from './SelectPlan';
import AddDay from './Days';
import PlanAssignmentForm from './PlanAssignmentForm';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      width: '100%',
    },
    button: {
      marginRight: theme.spacing(1),
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  };
});

function getSteps() {
  return ['Create or select a plan', 'Create or view tasks', 'Assign plan'];
}

export default function HorizontalLinearStepper() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [plan, setPlan] = React.useState({});
  const steps = getSteps();

  const isStepOptional = (step) => {
    return step === -1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => { return prevActiveStep + 1; });
    setSkipped(newSkipped);
  };

  const assignPlan = (selectedPlan) => {
    setPlan(selectedPlan);
    handleNext();
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <SelectPlan callBack={(selectedPlan) => { return assignPlan(selectedPlan); }} />
            <h3>OR</h3>
            <PlanForm callBack={(selectedPlan) => { return assignPlan(selectedPlan); }} />
          </div>
        );
      case 1:
        return <AddDay plan={plan} handleNext={handleNext} />;
      case 2:
        return <PlanAssignmentForm plan={plan} />;
      default:
        return 'Unknown step';
    }
  }

  // const handleBack = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep - 1);
  // };

  // const handleSkip = () => {
  //   if (!isStepOptional(activeStep)) {
  //     // You probably want to guard against something like this,
  //     // it should never occur unless someone's actively trying to break something.
  //     throw new Error("You can't skip a step that isn't optional.");
  //   }

  //   setActiveStep((prevActiveStep) => prevActiveStep + 1);
  //   setSkipped((prevSkipped) => {
  //     const newSkipped = new Set(prevSkipped.values());
  //     newSkipped.add(activeStep);
  //     return newSkipped;
  //   });
  // };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <Drawer>
      <div className={classes.root}>
        <Stepper activeStep={activeStep}>
          {steps.map((label, index) => {
            const stepProps = {};
            const labelProps = {};
            if (isStepOptional(index)) {
              labelProps.optional = <Typography variant="caption">Optional</Typography>;
            }
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              // eslint-disable-next-line react/jsx-props-no-spreading
              <Step key={label} {...stepProps}>
                <StepLabel
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...labelProps}
                >
                  {label}
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <div>
          {activeStep === steps.length ? (
            <div>
              <Typography className={classes.instructions}>
                All steps completed - you&apos;re finished
              </Typography>
              <Button onClick={handleReset} className={classes.button}>
                Reset
              </Button>
            </div>
          ) : (
            <div style={{ marginTop: 50 }}>
              <Container>
                {getStepContent(activeStep)}
              </Container>
              <div>
                {/* <div style={{background: 'yellow', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <Button disabled={activeStep === 0} onClick={handleBack} className={classes.button}>
                        Back
                    </Button>
                    {isStepOptional(activeStep) && (
                        <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSkip}
                        className={classes.button}
                        >
                        Skip
                        </Button>
                    )}

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleNext}
                        className={classes.button}
                    >
                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                    </Button>
                </div> */}
              </div>
            </div>
          )}
        </div>
      </div>
    </Drawer>
  );
}
